import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { MainComponent } from "./main/main.component";
import { SliderComponent } from "./slider/slider.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { CheckRouteService, LoginService } from "./PermissionGuard";
import { ScanCodeComponent } from "./scan-code/scan-code.component";
import { NewsDetailComponent } from "./news-detail/news-detail.component";
import { NewsListComponent } from "./news-list/news-list.component";
const routes: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  // { path: "main", component: MainComponent },
  { path: "main", component: MainComponent, canActivate: [LoginService] },
  { path: "slider", component: SliderComponent },
  { path: "wwopen", component: ScanCodeComponent },
  { path: "news/:id", component: NewsDetailComponent },
  { path: "newslist/:type", component: NewsListComponent },
  { path: "**", component: NotFoundComponent, canActivate: [CheckRouteService] }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/app-routing.module.ts